<template>
<div>
<b-card>
  <div slot="header" >
      <h4 class="mr-5 pull-left">{{$t('APPLICANTS')}}</h4>
        <app-button :c_permission="C_APPLICANT_NEW_BUTTON"
                    :to="{name: routeNames.RN_APPLICANT_NEW}"
                    button_type="new" variant="primary" class="pull-right">
          {{$t('NEW_APPLICANT')}}
        </app-button>
  </div>
  <applicant-filter @search="setFilter" :loading="loading" class="mb-3"></applicant-filter>
  <applicant-list-table  @busyToggled="toggleBusy"  :loading="loading" :filter="filter"></applicant-list-table>
</b-card>
</div>
</template>

<script>
  import routeNames from '@/router/routeNames'
  import AppButton from '@/components/app/AppButton'
  import ApplicantPagination from '@/components/applicant/list/ApplicantPagination'
  import ApplicantFilter from '@/components/applicant/list/ApplicantFilter'
  import {ECONOMY_VIEW_USER, INSTITUTION_USER, INSTITUTION_VIEW_USER, USER_DATA} from "@/shared/constants";
  import {C_APPLICANT_NEW_BUTTON} from '@/shared/component_permission'
  import AppNoData from "@/components/app/AppNoData";
  import ApplicantListTable from "@/components/applicant/list/ApplicantListTable";
  import {cloneDeep} from 'lodash'

  export default {
        name: "Index",
      data(){
          return {
            fields: [
              {key: 'first_name', label: this.$t('FIRST_NAME')},
              {key: 'last_name', label: this.$t('LAST_NAME')},
              {key: 'edit', label: this.$t('EDIT')},
            ],
            filter: {},
            routeNames,
            C_APPLICANT_NEW_BUTTON,
            loading:false
          }
      },
      components: {
        ApplicantListTable,
        AppNoData,
        ApplicantPagination,
        ApplicantFilter,
        AppButton
      },

      methods:{
        setFilter(values){

          this.filter = cloneDeep(values)

        },
        toggleBusy(value){
          this.loading = value
        }
       },
    computed:{
      user(){
        return JSON.parse(localStorage.getItem(USER_DATA))
      }
    },
    created(){
      if(this.user.role.id === INSTITUTION_USER || this.user.role.id === INSTITUTION_VIEW_USER){
        this.filter.institution =  this.user.institution.id
      }
      if(this.user.role.id === ECONOMY_VIEW_USER){
        this.filter.economy = this.user.economy.id
      }
    }
    }
</script>

<style scoped>

</style>
